import { LogoutCallback } from 'app/cross-cutting-concerns/authentication/components/LogoutCallback/LogoutCallback';
import { LoadingPage } from 'lib/components/LoadingPage/LoadingPage';

export const LogoutPage = (): JSX.Element => (
  <>
    <LogoutCallback />
    <LoadingPage />
  </>
);
